module.exports = __webpack_public_path__ + "img/Indoors.1d103eaa.svg";